import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { TextInput } from "../../../common/form";
import { FormattedMessage, intlShape } from "react-intl";

import validationUtils from "../../../../utils/ValidationUtils";
import { GROUP_VALIDATION_RULES } from "./groupValidationRules";

class BasicGroupFields extends React.Component {
    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <Field
                    id="name"
                    name="name"
                    component={TextInput}
                    type="text"
                    label={<FormattedMessage id="admin.groups.form.name" />}
                    required={!this.props.readOnly}
                    readOnly={this.props.readOnly}
                />
            </form>
        );
    }
}

BasicGroupFields.propTypes = {
    initialValues: PropTypes.object,
    handleSubmit: PropTypes.func,
    readOnly: PropTypes.bool,
};

export default connect(null, null, null, { withRef: true })(
    reduxForm({
        form: "group",
        validate: (values) =>
            validationUtils.validate(values, GROUP_VALIDATION_RULES),
    })(BasicGroupFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/groups/BasicGroupFields.js